import { Action, createReducer, on } from '@ngrx/store';
import { loginAuthInfoSuccessAction } from '../actions/auth.actions';
import { IAuthState } from '../../utils/interfaces/store.interfaces';

const initialState: IAuthState = {
  accessToken: null,
  userData: null
};

export const authReducerImplicit = createReducer(
  initialState,
  on(loginAuthInfoSuccessAction, (state, {data: {accessToken, userData}}) => ({
    ...state,
    accessToken,
    userData
  })),
);

export function authReducer(state: any, action: Action): IAuthState {
  return authReducerImplicit(state, action);
}
